module.exports = __webpack_public_path__ + "img/icons B_23.25c28e4a.svg";